import {get} from 'lodash';

export default (state: any, {imageType, isSaving}: any) => ({
  ...state,
  businessProfileImage: {
    ...get(state, 'businessProfileImage', {}),
    [imageType]: {
      ...get(state, `businessProfileImage.${imageType}`, {}),
      isSaving,
    },
  },
});
